import './hallmarks.scss';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Nav, NavItem, Well, Panel, PageHeader } from 'react-bootstrap';
import { Translate } from './../../common/translator.js';

export default class HallMarksView extends Component {
  _renderParamInfo(documentInfo, comments, modelCode) {

    const tmpFunksjon = documentInfo.find( elem => (elem.parameterName === 'Funksjon') ? true : false );
    const tmpBeskrivelse = documentInfo.find( elem => (elem.parameterName === 'Beskrivelse') ? true : false );
    const tmpLink = documentInfo.find( elem => (elem.parameterName === 'Link') ? true : false );
    const link = this.renderLink(tmpLink);
    const funksjon = (tmpFunksjon && tmpFunksjon.value) ? tmpFunksjon.value : '';
    let beskrivelse = (tmpBeskrivelse && tmpBeskrivelse.value && tmpBeskrivelse.value != 'null') ? tmpBeskrivelse.value : <i>Ingen avvik fra/Kommentar til spesifikasjon</i>;
    if(beskrivelse.replace)
      beskrivelse = beskrivelse.replace(new RegExp('\\r', 'g'), '\n');


    if (tmpFunksjon) {
      if (this.props.isMobilePhone) {
        return this.renderPhone(funksjon,beskrivelse,link, comments, modelCode);
      } else if(this.props.isTablet){
        return this.renderDesktop(funksjon,beskrivelse,link, comments, modelCode);
      }else{
       return this.renderDesktop(funksjon,beskrivelse,link, comments, modelCode);
      }

    } else {
      return (
        <h3>Naviger i treet for å finne et dokument</h3>
      );
    }
  }



  renderLink(tmpLink){
    const gotLink = (tmpLink && tmpLink.value && tmpLink.value != 'null');
    if(!gotLink){
      return <i>Ingen link lagt inn</i>;
    }

    var linkValue = tmpLink.value;

    if(linkValue.indexOf('www') > -1 && linkValue.indexOf("http") === -1){
      linkValue = 'http://' + linkValue;
    }
    if(linkValue.indexOf('ren.no') > -1){
      return <div>
                <i>Dokumentet ligger i REN. Kan kreve egen inlogging.</i><br/>
                <a className='hallmarkWordBreak' href={ linkValue }  target="_blank"> Klikk for å åpne</a>
              </div>
    } else{
      return  <a className='hallmarkWordBreak' href={ linkValue }  target="_blank"> Klikk for å åpne</a>
    }
  }

  renderComment(comment){

    var commentDate = comment.Timestamp;
    try{
      var date = new Date(comment.Timestamp);
      commentDate = date.getHours() + ':' + date.getMinutes() + ' ' + date.getDate() + '.' + date.getMonth() + '.' + date.getUTCFullYear()


    }catch(e){
      commentDate = comment.Timestamp;
    }

    return <div key={comment.Timestamp} className='commentContainer'>
            <b>{commentDate} av {comment.Username}</b>
            <br/>
            <span className='descriptionText'>{ comment.RevisionValue }</span>
            <br/>
            <br/>
          </div>
  }

  renderComments(comments){
    return <div>
            <hr/>
            <h4 style={{ textDecoration : 'underline'}}>Revisjonshistorikk</h4>
            <div className="commentsContainer">
              { comments && comments.length > 0 ? comments.map(this.renderComment) : 'Ingen revisjonshistorikk registrert'  }
            </div>
          </div>
  }

  renderPhone(funksjon, beskrivelse, link, comments){
      return <div>
                <h4>  { funksjon }</h4>
                <p className='descriptionText'> { beskrivelse }</p>
                {link}
                {this.renderComments(comments)}
            </div>;
  }

  renderDesktop(funksjon, beskrivelse, link, comments, modelCode){
    const style = {maxWidth:'750px'};
     return <div style={style}>
                <PageHeader><small> { funksjon }</small></PageHeader>
                <Panel header={<h2>Avvik fra/Kommentar til spesifikasjon</h2>}>
                  <span className='descriptionText'>{ beskrivelse }</span>
                  <br/><br/>
                  {link}
                  <br/>
                  <br/>
                  { modelCode != null && modelCode ==='DHH' ? this.renderComments(comments) : false }
                </Panel>
              </div>  }



  render() {
    const documentInfo = this.props.hallmarks.filter( elem => elem.idObject === this.props.idObject);
    const comments = this.props.comments.filter( elem => elem.idPlant === this.props.idPlant);
    return (
      <div className='hallmarkContainer'>
        { this._renderParamInfo(documentInfo, comments, this.props.modelCode) }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** app/components/docs-hallmarks/view/hallmarks-view.js
 **/